export default __webpack_public_path__ + "static/media/price.3511d2ee.png";